import { StandardEvents } from '@shopify/events';

// Use the same server-rendered variant response as the product price.
// Only the unit price determines eligibility; quantity and compare-at price do not.
class ProductDelivery extends HTMLElement {
  #section;
  #request = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#update);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#update);
    this.#request++;
  }

  #update = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = ++this.#request;
    event.promise.then(({ detail }) => {
      if (!this.isConnected || request !== this.#request || !detail?.html) return;
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) return;
      const replacement = [...detail.html.querySelectorAll('lt-product-delivery')]
        .find((element) => element.dataset.blockId === this.dataset.blockId);
      if (!replacement) return;
      this.dataset.productId = replacement.dataset.productId;
      this.replaceChildren(...[...replacement.childNodes].map((node) => node.cloneNode(true)));
    }).catch((error) => {
      if (error?.name !== 'AbortError') console.warn('[product-delivery] Update failed:', error);
    });
  };
}

if (!customElements.get('lt-product-delivery')) {
  customElements.define('lt-product-delivery', ProductDelivery);
}
